import { Controller } from 'react-hook-form';
import NRSelect from './NRSelect';

function NRControlledSelect({
  className,
  size,
  id,
  name,
  label,
  variant = 'outlined',
  helperText,
  control,
  rules,
  options,
  required = false,
  error,
  disabled = false,
  emptyValueLabel,
  showEmptyValue,
  displayEmpty,
  showIcon = true,
  sxProps,
  multiple = false
}) {
  return (
    <Controller
      control={control}
      id={id}
      name={name}
      data-testid={'controlledTestIdSelect'}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <NRSelect
          multiple={multiple}
          className={className}
          sxProps={sxProps}
          size={size}
          helperText={helperText}
          required={!!rules?.required || !!required}
          error={error}
          variant={variant}
          id={`label-${id}`}
          label={label}
          value={value}
          onChange={onChange}
          options={options}
          disabled={disabled}
          emptyValueLabel={emptyValueLabel}
          showEmptyValue={showEmptyValue}
          displayEmpty={displayEmpty}
          showIcon={showIcon}
        />
      )}
    />
  );
}

export default NRControlledSelect;
